module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.3-add-new-store.048fbfa3.png";